import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'phone',
  standalone: false,
})
export class PhonePipe implements PipeTransform {
  transform(phone: string | number | undefined): string {
    if (phone) {
      const value = phone.toString().replace(/\D/g, '');

      let formatted = '';

      if (value.length > 12) {
        formatted = value.replace(
          /(\d{2})?(\d{2})?(\d{5})?(\d{4})/,
          '+$1 ($2) $3-$4',
        );
      } else if (value.length > 11) {
        formatted = value.replace(
          /(\d{2})?(\d{2})?(\d{4})?(\d{4})/,
          '+$1 ($2) $3-$4',
        );
      } else if (value.length > 10) {
        formatted = value.replace(/(\d{2})?(\d{5})?(\d{4})/, '($1) $2-$3');
      } else if (value.length > 9) {
        formatted = value.replace(/(\d{2})?(\d{4})?(\d{4})/, '($1) $2-$3');
      } else if (value.length > 5) {
        formatted = value.replace(/^(\d{2})?(\d{4})?(\d{0,4})/, '($1) $2-$3');
      } else if (value.length > 1) {
        formatted = value.replace(/^(\d{2})?(\d{0,5})/, '($1) $2');
      } else {
        if (phone !== '') {
          formatted = value.replace(/^(\d*)/, '($1');
        }
      }
      return formatted;
    }
    return (phone ?? '').toString();
  }
}
